<template>
  <Modal :showing="isVisible" disable-scroll @close="close">
    <div v-if="loginDisabled" class="flex flex-col items-center">
      <LoginDisabledMassage :heading="$t('account.loginDisabledMassage')">
        <MaintenanceIcon class="h-16 fill-br-green" />
      </LoginDisabledMassage>
    </div>
    <LoginForm v-else class="max-w-sm" :from-uri="$route.path" forgot-password-over-button @success="handleSuccess">{{
      $t('account.modal.loginSaveExercises')
    }}</LoginForm>
  </Modal>
</template>

<script setup>
import { defineComponent, computed } from 'vue';
import Modal from '@/components/common/Modal';
import LoginForm from '@/components/account/LoginForm';
import LoginDisabledMassage from '@/components/account/LoginDisabledMassage';
import MaintenanceIcon from '@/components/icons/MaintenanceIcon';
import { useLoginModalStore } from '@/stores/login-modal';
import { useAccountStore } from '@/stores/account';

defineComponent({
  name: 'GlobalLoginModal',
  components: { LoginForm, Modal, LoginDisabledMassage, MaintenanceIcon },
});

const loginModalStore = useLoginModalStore();
const accountStore = useAccountStore();

const isVisible = computed(() => loginModalStore.visible || false);
const loginDisabled = computed(() => accountStore.loginDisabled);

const close = () => {
  loginModalStore.hideModal();
};

const handleSuccess = () => {
  loginModalStore.executeCallback();
};
</script>
